import { render, staticRenderFns } from "./shiming.vue?vue&type=template&id=024e170c"
import script from "./shiming.vue?vue&type=script&lang=js"
export * from "./shiming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports